import request from '@/utils/request'

export function getAgentWalletList(query) {
  return request({
    url: '/config-ticket-service/v1/agent/wallet',
    method: 'get',
    params: query
  })
}
export function rechargeAgentWallet(data) {
  return request({
    url: '/config-ticket-service/v1/agent/wallet/deposit',
    method: 'post',
    data
  })
}
export function getAgentWalletDetail(query) {
  return request({
    url: '/config-ticket-service/v1/agent/wallet/detail',
    method: 'get',
    params: query
  })
}

// get options
export function getTicketBankAcountListApi(query = {}) {
  return request({
    url: '/config-service/v1/bank-account/list/ticket',
    method: 'get',
    params: query
  })
}
